import axios from "axios";

export default () => ({
  userData: {},
  userPermissions: [],
  userRoles: [],
  isLoading: true,
  sidebarOpen: false,

  /**
   * Initialize global admin layout session.
   * Validates JWT token and fetches user authenticated details.
   */
  async initAdminLayout() {
    const token = localStorage.getItem("admin_jwt_token");

    if (!token) {
      window.location.href = "/admin/login";
      return;
    }

    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
      const response = await axios.get("/api/admin/auth/me");

      this.userData = response.data;
      this.userPermissions = response.data.permissions ?? [];
      this.userRoles = response.data.roles ?? [];

      this.isLoading = false;
    } catch (error) {
      console.error("Layout initialization failed:", error);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("admin_jwt_token");
        window.location.href = "/admin/login";
      } else {
        this.isLoading = false;
      }
    }
  },

  /**
   * Terminate admin user session and clear storage.
   */
  async logout() {
    try {
      await axios.post("/api/admin/auth/logout");
    } catch (error) {
      console.warn("Logout request failed on server.");
    } finally {
      localStorage.removeItem("admin_jwt_token");
      window.location.href = "/admin/login";
    }
  },

  /**
   * Check if current user has specific permission.
   * * @param {string} permission
   * @returns {boolean}
   */
  hasAdminPermission(permission) {
    return this.userPermissions.includes(permission);
  },

  /**
   * Check if current user has specific role.
   * * @param {string} role
   * @returns {boolean}
   */
  hasRole(role) {
    return this.userRoles.includes(role);
  },
});
